<div class="home-container">
  <!-- Hero Section -->
  <section class="hero-section">
    <div class="hero-background">
      <div class="floating-elements">
        <div class="floating-circle circle-1"></div>
        <div class="floating-circle circle-2"></div>
        <div class="floating-circle circle-3"></div>
        <div class="floating-circle circle-4"></div>
      </div>
    </div>

    <div class="hero-content">
      <div class="hero-badge">
        <!-- <span class="badge-icon">✨</span> -->
        <span>A Software Company</span>
      </div>

      <h1 class="hero-title damion-regular">
        <span class="title-word">Innovation Meets Excellence</span>
      </h1>

      <p class="hero-description">
        Transforming ideas into powerful digital solutions that drive your
        business forward
      </p>

      <div class="hero-stats">
        <div class="stat-item">
          <div class="stat-number">500+</div>
          <div class="stat-label">Projects Delivered</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">50+</div>
          <div class="stat-label">Happy Clients</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">24/7</div>
          <div class="stat-label">Support</div>
        </div>
      </div>
    </div>
  </section>
  <section class="apps-carousel-section py-5 bg-light">
    <div class="container">
      <div class="section-header">
        <h2 class="text-center">Our Products</h2>
        <div _ngcontent-ng-c3938324425="" class="section-underline"></div>
      </div>
      <div id="productCarousel" class="carousel slide" data-bs-ride="carousel" data-bs-interval="6000">
        <!-- Carousel Inner -->
        <div class="carousel-inner pt-2">
          <div class="carousel-item" *ngFor="let appGroup of groupedApps; let i = index" [class.active]="i === 0">
            <div class="row gy-3">
              <div *ngFor="let app of appGroup" class="col-lg-4 col-md-6">
                <div class="card h-100 shadow-sm rounded-4 p-4">
                  <img [src]="app.logoUrl || 'assets/placeholder.png'" class="card-img-top mx-auto d-block"
                    [alt]="app.title || 'App Logo'" style="height: 50px; width: auto; object-fit: contain" />

                  <div class="card-body text-center px-0">
                    <h6 class="card-title fw-bold">{{ app.title }}</h6>
                    <p class="card-text text-muted">
                      {{ app.description || "No description available." }}
                    </p>
                  </div>
                  <div class="row g-2 justify-content-center mt-2" *ngIf="app.isWaitListActive == false">
                    <div class="col-auto">
                      <button class="gold-btn px-3" (click)="openWebsite(app.websiteUrl)">
                        Visit Website →
                      </button>
                    </div>
                    <div class="col-auto">
                      <button class="gold-btn gold-outline px-3" (click)="openWebsite(app.storeUrl)">
                        Visit Store →
                      </button>
                    </div>
                  </div>
                  <div class="row g-2 justify-content-center mt-2" *ngIf="app.isWaitListActive == true">
                    <div class="col-auto">
                      <button class="gold-btn px-3" (click)="openWebsite(app.websiteUrl)">
                        Visit Website →
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Enhanced Maxgeneye Section -->
  <section class="maxgeneye-section">
    <div class="section-header">
      <h2 class="section-title">Featured Product</h2>
      <div class="section-underline"></div>
    </div>

    <div class="body-content-container" *ngIf="this.isAnyFeatureProducts">
      <!-- Animated background elements -->
      <div class="floating-elements">
        <div class="floating-circle circle-1"></div>
        <div class="floating-circle circle-2"></div>
        <div class="floating-circle circle-3"></div>
      </div>

      <div class="maxgeneye-inner">
        <div class="bc-left">
          <div class="bc-left-botton p-0 m-0">
            <div class="py-2">
              <div class="description-content">
                <div class="feature-badge">
                  <span>{{
                    this.featureProduct?.Tag ?? "Revolutionary Platform"
                    }}</span>
                </div>
                <div class="title-container">
                  <h2 class="body-content-title mb-4">
                    <span>{{ this.featureProduct?.Title ?? "Maxgeneye" }}</span>
                  </h2>
                </div>
                <p class="main-description">
                  {{
                  this.featureProduct?.Description ??
                  "A powerful website that allows users to never have to apply to jobs again."
                  }}
                </p>
                <div class="feature-list" *ngFor="
                    let product of [
                      'AI-Powered Job Matching',
                      'Automated Applications',
                      'Smart Profile Optimization',
                    ]
                  ">
                  <div class="feature-item">
                    <span class="feature-dot"></span>
                    <span>{{ product }}</span>
                  </div>
                </div>
                <div class="mt-4">
                  <button type="button" class="btn btn-button enhanced-button" (click)="visitMaxgeneye()">
                    <span class="button-content">
                      <span class="button-text">Visit Website</span>
                      <span class="button-arrow">→</span>
                    </span>
                    <div class="button-glow"></div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="bc-right">
          <div class="logo-container">
            <div class="logo-wrapper">
              <div class="logo-glow-effect"></div>
              <img [src]="getFeatureLogo()" alt="Maxgeneye logo" class="logo-image" />
              <div class="logo-particles">
                <div class="particle particle-1"></div>
                <div class="particle particle-2"></div>
                <div class="particle particle-3"></div>
                <div class="particle particle-4"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Decorative elements -->
      <div class="decorative-lines">
        <div class="line line-1"></div>
        <div class="line line-2"></div>
        <div class="line line-3"></div>
      </div>
    </div>
  </section>
</div>